// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2a-q";
export var animationRelative = "_2a-p";
export var backdropBlur = "_2a-0";
export var detailLabelCell = "_2a-12";
export var detailTable = "_2a-11";
export var detailValueCell = "_2a-13";
export var docIconBox = "_2a-1d";
export var docIconBoxMd = "_2a-1f";
export var docIconBoxSm = "_2a-1e";
export var docTypeRow = "_2a-16";
export var docTypeRowInner = "_2a-17";
export var dropdownMatchDatePicker = "_2a-3";
export var evidenceCardContent = "_2a-1c";
export var fileUploadSpin = "_2a-j";
export var gorgiasOpenButton = "_2a-15 _2a-d";
export var gorgiasTicketCard = "_2a-14";
export var heroModalFooterButton = "_2a-18";
export var hiddenContainer = "_2a-o";
export var iconPrimary = "_2a-1g";
export var iconQuaternary = "_2a-1i";
export var iconTertiary = "_2a-1h";
export var integrationCard = "_2a-1";
export var integrationLogoBox = "_2a-2";
export var mainColumnSticky = "_2a-1b";
export var maxWidthContainer = "_2a-19";
export var modalContentBody = "_2a-a";
export var modalHeaderImage = "_2a-5";
export var modalImageLabel = "_2a-7";
export var modalImageOverlay = "_2a-6";
export var modalImageSubtitle = "_2a-9";
export var modalImageTitle = "_2a-8";
export var modalImageWrapper = "_2a-4";
export var modalStickyFooter = "_2a-b";
export var removeButton = "_2a-e";
export var sidebarColumn = "_2a-1a";
export var spinner = "_2a-i";
export var timelineLine = "_2a-y";
export var timelineLineBlack = "_2a-10 _2a-y";
export var timelineLineGray = "_2a-z _2a-y";
export var timelineLineHeight = "_2a-x";
export var tlDotActivate = "_2a-u";
export var tlDotActivateAnim = "_2a-t";
export var tlDotHide = "_2a-s";
export var tlDotHideAnim = "_2a-r";
export var tlLineActivate = "_2a-w";
export var tlLineActivateAnim = "_2a-v";
export var uploadHint = "_2a-n";
export var uploadIconBox = "_2a-k";
export var uploadLabel = "_2a-m";
export var uploadText = "_2a-l";
export var uploadZone = "_2a-f";
export var uploadZoneCursorDefault = "_2a-h";
export var uploadZoneCursorPointer = "_2a-g";
export var uploadedFileRow = "_2a-c";
export var viewButton = "_2a-d";